import { render, staticRenderFns } from "./SubscriptionPlanEdit.vue?vue&type=template&id=c8535546"
import script from "./SubscriptionPlanEdit.vue?vue&type=script&lang=js"
export * from "./SubscriptionPlanEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports